import { CURRENT_PAGE_ACTION_TYPE } from 'store/global/actions';

const initialState = {
  pageCode: null,
};

const currentPageReducer = function (state = initialState, { type, payload }) {
  switch (type) {
    case CURRENT_PAGE_ACTION_TYPE.SET_PAGE_CODE:
      return { ...state, pageCode: payload };

    default:
      return state;
  }
};

export default currentPageReducer;
